import Icon from '@material-ui/icons/ListAlt';
import InsList from './InsList'

export default {
    list: InsList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
